/**
 * ComparisonControl (FEAT-ANALYTICS-002) — GA "Add comparison +". Pick up to 4
 * audiences (incl. "All users") to compare; selected ones show as colored chips.
 * When ≥2 are active the content pane switches to the ComparisonDashboard.
 */
import React from 'react';
import {
  Menu, MenuButton, MenuList, MenuItemOption, MenuOptionGroup, Button, HStack, Tag,
  TagLabel, TagCloseButton, Box,
} from '@chakra-ui/react';
import { FiPlus } from 'react-icons/fi';

const MAX = 4;
const PALETTE = ['#2563eb', '#16a34a', '#f59e0b', '#dc2626'];

// comparisons: [{ key, name, definition|null, color }]
export function ComparisonControl({ audiences = [], comparisons = [], onChange }) {
  const options = [
    { key: 'all', name: 'All users', definition: null },
    ...audiences.map((a) => ({ key: `aud-${a.id}`, name: a.name, definition: a.definition })),
  ];
  const selectedKeys = comparisons.map((c) => c.key);
  const atMax = comparisons.length >= MAX;

  const recolor = (arr) => arr.map((c, i) => ({ ...c, color: PALETTE[i % PALETTE.length] }));
  const onMenu = (keys) => {
    const arr = (Array.isArray(keys) ? keys : [keys]).slice(0, MAX);
    onChange(recolor(arr.map((k) => options.find((o) => o.key === k)).filter(Boolean)));
  };
  const remove = (k) => onChange(recolor(comparisons.filter((c) => c.key !== k)));

  return (
    <HStack spacing={2} flexWrap="wrap">
      <Menu closeOnSelect={false}>
        <MenuButton as={Button} size="sm" variant="outline" bg="white" leftIcon={<FiPlus />}>Add comparison</MenuButton>
        <MenuList maxH="320px" overflowY="auto">
          <MenuOptionGroup type="checkbox" value={selectedKeys} onChange={onMenu}>
            {options.map((opt) => (
              <MenuItemOption key={opt.key} value={opt.key} fontSize="sm"
                isDisabled={atMax && !selectedKeys.includes(opt.key)}>
                {opt.name}
              </MenuItemOption>
            ))}
          </MenuOptionGroup>
        </MenuList>
      </Menu>
      {comparisons.map((c) => (
        <Tag key={c.key} size="sm" borderRadius="full" variant="subtle">
          <Box w="8px" h="8px" borderRadius="full" bg={c.color} mr={1} />
          <TagLabel>{c.name}</TagLabel>
          <TagCloseButton onClick={() => remove(c.key)} />
        </Tag>
      ))}
    </HStack>
  );
}

export default ComparisonControl;
